import DiscreetInput from './DiscreetInput';
import DiscussionSubmission from './DiscussionSubmission';
import ErrorPage from './ErrorPage';
import FormEditHeader from './FormEditHeader';
import FormGroup from './FormGroup';
import FormSortDropdown from './FormSortDropdown';
import FormTitle from './FormTitle';
import GlobalSettings from './GlobalSettings';
import LinkedFormFill from './LinkedFormFill';
import PageContainer from './PageContainer';
import PermissionDropdown from './PermissionDropdown';
import RichTextField from './RichTextField';
import SaveControls from './SaveControls';
import SettingsLinkButton from './SettingsLinkButton';
import Sortable from './Sortable';
import SortableHandle from './SortableHandle';
import SubmissionSortDropdown from './SubmissionSortDropdown';
import ValidationErrors from './ValidationErrors';

export const components = {
    DiscreetInput,
    DiscussionSubmission,
    ErrorPage,
    FormEditHeader,
    FormGroup,
    FormSortDropdown,
    FormTitle,
    GlobalSettings,
    LinkedFormFill,
    PageContainer,
    PermissionDropdown,
    RichTextField,
    SaveControls,
    SettingsLinkButton,
    Sortable,
    SortableHandle,
    SubmissionSortDropdown,
    ValidationErrors,
};
